import MedicationFilterForm from "../MedicationFilterForm";
import AppMobileBottomNavContainer from "../AppMobileBottomNavContainer";

const MedicationFilterMobileNavbar = ({ isOpen, setIsOpen }) => {
  return (
    <AppMobileBottomNavContainer isOpen={isOpen} setIsOpen={setIsOpen}>
      <MedicationFilterForm onClose={() => setIsOpen(false)} />
    </AppMobileBottomNavContainer>
  )
}

export default MedicationFilterMobileNavbar